import {
  CheckSquareOutlined,
  FileAddOutlined,
  FileOutlined,
  LockOutlined,
  PieChartOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons'

export const pagesList = [
  {
    categorie: 'CarnetDeLiaison',
    intitule: 'Encodage du carnet de liaison',
    icon: <FileAddOutlined />,
    script: 'CarnetDeLiaisonEncodage',
    visible: true,
    position: 'top',
  },
  {
    categorie: 'CarnetDeLiaison',
    intitule: 'Lecture du carnet de liaison',
    icon: <FileOutlined />,
    script: 'CarnetDeLiaisonLecture',
    visible: true,
    position: 'top',
  },

  {
    categorie: 'Absences',
    intitule: 'Encodage des absences',
    icon: <CheckSquareOutlined />,
    script: 'AbsencesEncodage',
    visible: true,
    position: 'top',
  },
  {
    categorie: 'Absences',
    intitule: 'Lecture des statistiques',
    icon: <PieChartOutlined />,
    script: 'AbsencesLecture',
    visible: false,
    position: 'top',
  },
  {
    categorie: 'prof',
    intitule: 'Mes infos',
    icon: <UserOutlined />,
    script: 'MesInfos',
    visible: true,
    position: 'bottom',
  },
  {
    categorie: 'parametres',
    intitule: 'Paramètres',
    icon: <SettingOutlined />,
    script: 'Parametres',
    visible: true,
    position: 'top',
  },
]
